<template>
  <section>
    <div class="g-4 mb-16">
      <div class="card card-sm stat-card">
        <div class="stat-lbl">Facturas</div>
        <div class="stat-val">{{ data.facturas.total || 0 }}</div>
        <div class="stat-sub">{{ fmt(data.facturas.monto) }} facturado</div>
      </div>
      <div class="card card-sm stat-card">
        <div class="stat-lbl">Saldo por cobrar</div>
        <div class="stat-val">{{ fmt(data.cuentas.saldo_total) }}</div>
        <div class="stat-sub">
          <span class="pill" :class="Number(data.cuentas.saldo_total) > 0 ? 'pill-a' : 'pill-g'">
            {{ Number(data.cuentas.saldo_total) > 0 ? 'en revisión' : 'al día' }}
          </span>
        </div>
      </div>
      <div class="card card-sm stat-card">
        <div class="stat-lbl">Clientes activos</div>
        <div class="stat-val">{{ data.clientes.total || 0 }}</div>
        <div class="stat-sub"><span class="pill pill-s">con actividad</span></div>
      </div>
      <div class="card card-sm stat-card">
        <div class="stat-lbl">Pendientes / Vencidas</div>
        <div class="stat-val">{{ data.facturas.pendientes || 0 }}</div>
        <div class="stat-sub"><span class="pill pill-r" v-if="data.facturas.vencidas">{{ data.facturas.vencidas }} vencidas</span></div>
      </div>
    </div>

    <div class="g-2">
      <div class="card card-p">
        <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:12px">
          <span class="c-lbl">Últimas facturas</span>
          <router-link to="/facturas" class="btn btn-g btn-sm">Ver todas →</router-link>
        </div>
        <div v-if="loading" class="tbl-empty">Cargando...</div>
        <div v-else-if="!data.ultimas.length" class="tbl-empty">Sin facturas todavía.</div>
        <table v-else class="tbl">
          <tbody>
            <tr v-for="f in data.ultimas" :key="f.id">
              <td class="mono">{{ f.numero }}</td>
              <td>{{ f.cliente?.nombre }}</td>
              <td class="mono" style="text-align:right">{{ fmt(f.monto_total) }}</td>
              <td><span class="pill" :class="estadoPill(f.estado)">{{ f.estado }}</span></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="card card-p">
        <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:12px">
          <span class="c-lbl">Top deudores</span>
          <router-link to="/cuentas" class="btn btn-g btn-sm">Ver todos →</router-link>
        </div>
        <div v-if="loading" class="tbl-empty">Cargando...</div>
        <div v-else-if="!data.deudores.length" class="tbl-empty">Sin deudores. Todo cobrado.</div>
        <table v-else class="tbl">
          <tbody>
            <tr v-for="cc in data.deudores" :key="cc.id">
              <td><strong style="color:var(--tx-hi)">{{ cc.cliente?.nombre }}</strong></td>
              <td class="mono" style="text-align:right"><strong class="grad-text">{{ fmt(cc.saldo, cc.moneda) }}</strong></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>
</template>

<script>
import api from '../services/api';
export default {
  name: 'DashboardView',
  data() {
    return {
      loading: true,
      data: {
        facturas: { total: 0, monto: 0, pendientes: 0, vencidas: 0 },
        cuentas:  { total: 0, saldo_total: 0, con_saldo: 0 },
        clientes: { total: 0 },
        ultimas: [], deudores: []
      }
    };
  },
  async mounted() {
    try {
      const { data } = await api.get('/dashboard');
      this.data = data;
    } catch (e) {
      if (!e?.isAuthExpired) console.warn('[Dashboard]', e);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    estadoPill(e) { return ({ pendiente: 'pill-a', pagada: 'pill-g', vencida: 'pill-r', anulada: 'pill-b' })[e] || 'pill-b'; },
    fmt(n, m='ARS') { return new Intl.NumberFormat('es-AR', { style:'currency', currency:m, maximumFractionDigits:0 }).format(Number(n||0)); }
  }
};
</script>
